// ============================================
// scrollLock.js — Bloqueo de scroll sin layout shift
// Bloquea scroll en html Y body para cubrir todos los navegadores
// Compensa el ancho del scrollbar con padding-right
// Soporta locks anidados (varios modales abiertos)
// ============================================

let lockCount = 0;
let savedPaddingRight = '';

function getScrollbarWidth() {
  return window.innerWidth - document.documentElement.clientWidth;
}

export function lockScroll() {
  lockCount++;
  if (lockCount === 1) {
    const scrollbarWidth = getScrollbarWidth();
    savedPaddingRight = document.body.style.paddingRight;

    // Block scroll on both html and body
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // Compensate scrollbar width
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }
}

export function unlockScroll() {
  lockCount = Math.max(0, lockCount - 1);
  if (lockCount === 0) {
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = savedPaddingRight;
  }
}

// Force reset (for edge cases like navigating away)
export function resetScrollLock() {
  lockCount = 0;
  document.documentElement.style.overflow = '';
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
}
